/* global axios */
import ApiClient from './ApiClient';

class GamificationAPI extends ApiClient {
  constructor() {
    super('gamification', { accountScoped: true });
  }

  settings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(gamificationSetting) {
    return axios.patch(`${this.url}/settings`, {
      gamification_setting: gamificationSetting,
    });
  }

  rules() {
    return axios.get(`${this.url}/rules`);
  }

  createRule(gamificationRule) {
    return axios.post(`${this.url}/rules`, {
      gamification_rule: gamificationRule,
    });
  }

  updateRule(id, gamificationRule) {
    return axios.patch(`${this.url}/rules/${id}`, {
      gamification_rule: gamificationRule,
    });
  }

  participants() {
    return axios.get(`${this.url}/participants`);
  }

  updateParticipants(participants) {
    return axios.post(`${this.url}/participants`, { participants });
  }

  manualEntry(gamificationEntry) {
    return axios.post(`${this.url}/manual_entries`, {
      gamification_entry: gamificationEntry,
    });
  }

  reverseEntry(id, reason) {
    return axios.post(`${this.url}/manual_entries/${id}/reverse`, { reason });
  }

  leaderboard(params = {}) {
    return axios.get(`${this.url}/leaderboard`, { params });
  }

  profile(userId) {
    return axios.get(`${this.url}/profiles/${userId}`);
  }

  activities(params = {}) {
    return axios.get(`${this.url}/activities`, { params });
  }

  createComment(activityId, body) {
    return axios.post(`${this.url}/activities/${activityId}/comments`, {
      body,
    });
  }

  createReaction(activityId, kind = 'like') {
    return axios.post(`${this.url}/activities/${activityId}/reactions`, {
      kind,
    });
  }

  achievements() {
    return axios.get(`${this.url}/achievements`);
  }

  createAchievement(gamificationAchievement) {
    return axios.post(`${this.url}/achievements`, {
      gamification_achievement: gamificationAchievement,
    });
  }

  updateAchievement(id, gamificationAchievement) {
    return axios.patch(`${this.url}/achievements/${id}`, {
      gamification_achievement: gamificationAchievement,
    });
  }
}

export default new GamificationAPI();
